module.exports = __webpack_public_path__ + "img/vendor-manage.89247c79.svg";